import React, {useEffect} from 'react';
import {useEditBenefactorForm} from '../../model';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useParams} from 'react-router';
import {BenefactorModel} from '../../../../entities';

interface EditBenefactorModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  benefactor?: BenefactorModel;
}

export const EditBenefactorModal = ({open, setOpen, benefactor}: EditBenefactorModalProps) => {
  const params = useParams();

  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useEditBenefactorForm({setOpen, benefactorId: params.id ?? '', benefactor});

  const {isErrorModalOpen, errorInfo, handleClose, handleError} = useErrorHandler({
    resourceName: 'Пользователь',
    title: 'Ошибка при обновлении пользователя',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  return (
    <>
      {' '}
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактирование'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Real name"
          placeholder="Настоящее имя"
          name="realName"
          value={values.realName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.realName && errors.realName}
        />
        <FormInput
          label="Display name"
          placeholder="Имя"
          name="displayName"
          value={values.displayName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.displayName && errors.displayName}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
